import { render } from "./TvmPreLoader.vue?vue&type=template&id=34b920f6&scoped=true"
import script from "./TvmPreLoader.vue?vue&type=script&lang=js"
export * from "./TvmPreLoader.vue?vue&type=script&lang=js"

import "./TvmPreLoader.vue?vue&type=style&index=0&id=34b920f6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34b920f6"]])

export default __exports__